import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { BodegaService } from 'src/app/services/bodega.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { MotivoDevolucionService } from 'src/app/services/motivo-devolucion.service';

@Component({
  selector: 'app-motivo-devolucion-modal-add-edit',
  templateUrl: './modal-add-edit.component.html',
  styleUrls: ['./modal-add-edit.component.scss'],
  providers: [SecurityService],
})
export class MotivoDevolucionModalAddEditComponent implements OnInit {

  // Modales
  @ViewChild('agregarMotivo', { static: true }) modalAddEditMotivoDevolucion: ModalDirective;

  @Output() onAddEdit: EventEmitter<any> = new EventEmitter()

  // Form
  formData: FormGroup

  // Data &  Tmp
  optionsBodega: Array<any> = [];
  isEditing: boolean = false
  codigoEditado = 0
  private rutEmpresa: number
  private sucursalCodigo: number

  // Utils

  constructor(
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private bodegaService: BodegaService,
    private accesolocalstorage: SecurityService,
    private motivoDevolucionService: MotivoDevolucionService,
  ) { }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo())
    this.createForm()
    this.loadBodega()
  }

  loadBodega() {
    this.bodegaService.GetBodegas(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }))
      this.formValidatorsService.selectFirstOrDefault(this.formData.get('bodega'), this.optionsBodega)
    })
  }

  private createForm() {
    this.formData = this.fb.group({
      activo: [false, [Validators.required]],
      descripcion: [null, [Validators.required, Validators.maxLength(100), Validators.minLength(2)]],
      bodega: [null, [Validators.required]]
    });
  }

  show() {
    this.isEditing = false
    this.clearData()
    this.modalAddEditMotivoDevolucion.show()
  }

  hide() {
    this.modalAddEditMotivoDevolucion.hide()
  }

  load(motivo) {
    this.isEditing = true
    this.codigoEditado = motivo.codigo
    this.clearData()
    this.formData.get('activo').setValue(motivo.activo)
    this.formData.get('descripcion').setValue(motivo.descripcion)
    this.formData.get('bodega').setValue(motivo.bodega_codigo)
    this.modalAddEditMotivoDevolucion.show()
  }

  clearData() {
    this.formValidatorsService.reset(this.formData)
    this.formData.get('activo').setValue(false)
  }

  addEdit() {
    this.formValidatorsService.validateAllFormFields(this.formData)
    if (!this.formData.valid)
      return

    const inputParams: any = {
      entidad: {
        activo: this.formData.get('activo').value,
        descripcion: this.formData.get('descripcion').value,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        bodega_codigo: Number(this.formData.get('bodega').value),
      }
    }
    if (this.isEditing)
      inputParams.entidad.codigo = this.codigoEditado

    this.motivoDevolucionService.guardar(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastrService.success('Operación realizada con éxito')
      this.onAddEdit.emit(respuesta)
      this.hide()
    })
  }

}

